import React, { createContext, useContext, useState } from "react";
import { UserContext } from "./Components/UserContext";
import { useCallSocket } from "./hooks/useCallSocket";

const SocketContext = createContext(null);

export const ContextProvider = ({ children }) => {
  const { user } = useContext(UserContext);

  // UI state only (NOT socket logic)
  const [mute, setMute] = useState(false);
  const [videoOff, setVideoOff] = useState(false);

  // All socket + WebRTC logic lives here
  const {
    remoteVideo,
    callUser,
    stopCall,
  } = useCallSocket({
    user,
    videoOff,
    mute,
  });

  return (
    <SocketContext.Provider
      value={{
        // media
        remoteVideo,

        // call actions
        callUser,
        stopCall,

        // UI controls
        mute,
        setMute,
        videoOff,
        setVideoOff,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

/* ---------- Helper Hook ---------- */

export const useSocket = () => {
  const ctx = useContext(SocketContext);
  if (!ctx) {
    throw new Error("useSocket must be used inside ContextProvider");
  }
  return ctx;
};
